<template>
  <div id="home-carousel" class="swiper-container">
    <div class="scroll-down">
      <button type="button" @click="scrollDown()">
        <ArrowCarouselDown />
      </button>
    </div>
    <div class="swiper-wrapper">
      <div v-for="slide in formatUrlFromCarouselType"
           :key="slide.permlink"
           class="swiper-slide"
      >
        <div class="carousel-card">
          <div class="carousel-card__inner">
            <div class="carousel-card__inner__image">
              <img :src="$router.options.imagePath + slide.mediaUrl" />
              <div class="carousel-card__inner__image__link">
                <router-link
                  :class="`carousel-link carousel-link--${slide.type}`"
                  :to="{
                    name: slide.routeName,
                    params: { id: slide.permlink }
                  }"
                >
                  {{ setCasouelLinkTextFromType(slide.type) }}
                </router-link>
              </div>
            </div>
            <div class="carousel-card__inner__card">
              <div class="info-card">
                <div class="info-card__inner">
                  <router-link
                    :to="{
                      name: slide.routeName,
                      params: { id: slide.permlink }
                    }"
                  >
                    <div class="info-card__inner__title">
                      {{ slide.title }}
                    </div>
                    <div class="info-card__inner__artist">
                      <div v-if="slide.mainArtist" class="info-card__inner__artist__main">
                        w/ {{ slide.mainArtist }}
                      </div>
                    </div>
                  </router-link>
                  <div
                    v-if="slide.description"
                    class="info-card__inner__description"
                    v-html="slide.description"
                  />
                  <div class="info-card__inner__date">
                    <template v-if="slide.date != null && slide.location != null">
                      {{ slide.location }} - {{ formatDate(slide.date) }}
                    </template>
                    <template v-else-if="slide.location != null">
                      {{ slide.location }}
                    </template>
                    <template v-else>
                      {{ formatDate(slide.date) }}
                    </template>
                  </div>
                  <div class="info-card__inner__link">
                    <router-link
                      :class="`carousel-link carousel-link--${slide.type}`"
                      :to="{
                        name: slide.routeName,
                        params: { id: slide.permlink }
                      }"
                    >
                      {{ setCasouelLinkTextFromType(slide.type) }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!hasCarouselSingleSlide">
      <div :id="`home-carousel-prev-${carouselId}`" class="swiper-button-prev home">
        <ArrowCarouselPrev />
      </div>
      <div :id="`home-carousel-next-${carouselId}`" class="swiper-button-next home">
        <ArrowCarouselNext />
      </div>
    </template>
  </div>
</template>
<script>
import Swiper, {Autoplay, Navigation} from 'swiper';
import ArrowCarouselPrev from '@/components/svg/ArrowCarouselPrev.vue';
import ArrowCarouselNext from '@/components/svg/ArrowCarouselNext.vue';
import ArrowCarouselDown from '@/components/svg/ArrowCarouselDown.vue';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

Swiper.use(Autoplay);
Swiper.use(Navigation);
export default {
  name: 'HomeCarousel',
  components: {
    ArrowCarouselPrev,
    ArrowCarouselNext,
    ArrowCarouselDown
  },
  props: {
    carousel: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      carouselId: 'home',
      carouselConfig: {
        enabled: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        speed: 1000,
        loop: true,
        simulateTouch: true,
        navigation: {
          nextEl: '#home-carousel-next-home',
          prevEl: '#home-carousel-prev-home'
        }
      }
    };
  },
  computed: {
    formatUrlFromCarouselType() {
      const entiryTypeToRouteName = entityType => {
        switch (entityType) {
          case 'series':
            return 'Serie';
          case 'episode':
            return 'Show';
          case 'podcast':
            return 'Podcasts';
          default:
            return entityType;
        }
      };
      return this.carousel.map(e => ({
        ...e,
        routeName: entiryTypeToRouteName(e.type)
      }));
    },
    hasCarouselSingleSlide() {
      return this.carousel.length === 1;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.carouselConfig.enabled = !this.hasCarouselSingleSlide; // set enabled option to true if carousel has more than 1 slides
      this.initCarousel();
    });
  },
  methods: {
    initCarousel() {
      new Swiper('#home-carousel', this.carouselConfig);
    },
    setCasouelLinkTextFromType(type) {
      const typeName = type => {
        switch (type) {
          case 'podcast':
            return 'Listen back show';
          case 'episode':
            return 'Listen back episode';
          case 'series':
            return 'Explore series';
          default:
            return type;
        }
      };
      return typeName(type);
    },
    scrollDown() {
      window.scrollTo({
        top: 500,
        left: 0,
        behavior: 'smooth'
      });
    },
    formatDate(date) {
      return date
          .split('-')
          .reverse()
          .join('.');
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_home-carousel.scss';
</style>
